module.exports = __webpack_public_path__ + "img/Einblick_PC_Mockup.75518734.png";